import { domain } from 'modules/data';

import { CheckBeneficiaryResult } from './XeroAirwallexBatchPaymentForm.types';

export const getInitialCheckBeneficiaryResultsByInvoiceId = (
    billBatchPayment: domain.XeroAirwallexBatchPayment
): Record<string, CheckBeneficiaryResult> => {
    return billBatchPayment.items.reduce((acc, item) => {
        if (!item.beneficiaryPaymentStatus) return acc;

        return {
            ...acc,
            [item.xeroBillInvoiceRequestId]: {
                status: item.beneficiaryPaymentStatus,
                beneficiaryDiscrepancy: item.beneficiaryDiscrepancy,
            },
        };
    }, {});
};
